import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { C } from "./constants";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Features from "./pages/Features";
import HowItWorks from "./pages/HowItWorks";
import ForApprovers from "./pages/ForApprovers";
import ForUsers from "./pages/ForUsers";
import Pricing from "./pages/Pricing";
import Demo from "./pages/Demo";
import Compliance from "./pages/Compliance";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import DeleteAccount from "./pages/DeleteAccount";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
}

export default function SafeZappApp() {
  return (
    <div style={{ fontFamily: "'Nunito', sans-serif", background: C.bg, minHeight: "100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap" rel="stylesheet" />
      <style>{`
        @media (max-width: 920px) {
          .sz-nav-desk { display: none !important; }
          .sz-nav-mob { display: block !important; }
        }
        @media (min-width: 921px) { .sz-nav-mob { display: none !important; } }
        * { box-sizing: border-box; }
        a { color: inherit; }
        ::selection { background: ${C.blueLight}; color: ${C.blueDark}; }
      `}</style>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/features" element={<Features />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/for-approvers" element={<ForApprovers />} />
        <Route path="/for-users" element={<ForUsers />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </div>
  );
}
